import * as Sentry from '@sentry/browser'

type BridgeNavigatePayload = {
  page?: string,
  detail?: string
}
type BridgeMessage = {
  source?: string,
  type?: string,
  version?: number,
  requestId?: string,
  payload?: BridgeNavigatePayload
}

export default defineNuxtPlugin((nuxtApp) => {
  if (window.parent === window) { return }
  const eid = new URLSearchParams(window.location.search).get('eid')
  if (!eid) { return }

  const extensionOrigin = `chrome-extension://${eid}`
  const { extension } = storeToRefs(useChromeExtensionStore())

  const reply = (type: string, requestId?: string, error?: string) => {
    window.parent.postMessage(
      { source: 'emissary-webapp', type, version: 1, requestId, error },
      extensionOrigin
    )
  }

  window.addEventListener('message', async (event: MessageEvent<BridgeMessage>) => {
    if (event.origin !== extensionOrigin) { return }
    const message = event.data
    if (message?.source !== 'emissary-extension' || message.type !== 'navigate') { return }
    reply('navigate-ack', message.requestId)
    try {
      const page = String(message.payload?.page || '')
      const detail = String(message.payload?.detail || '')
      extension.value = { eid, page, detail }
      await navigateTo({ path: '/inbox-redirect/', query: { page, detail, _ts: Date.now().toString() } })
      reply('navigate-done', message.requestId)
    } catch (error) {
      Sentry.captureException(error)
      reply('navigate-error', message.requestId, error instanceof Error ? error.message : String(error))
    }
  })

  nuxtApp.hook('app:mounted', () => {
    reply('bridge-ready')
  })
})
